import React from 'react'
import '../App.css'
import Bodyhomeadminwallet from './bodyhomeadminwallet'
export class Bodyapphomebodyadminwallet extends React.Component {
    state = {
    }
    render() {       
        return (
            <div className='w-full'>
                <Bodyhomeadminwallet />
            </div>
        );
    }
}